
import {
  defineComponent, PropType, ref, watch,
} from 'vue';
import { WidgetTitleData } from '@/components/stats-builder/metadata/WidgetTitleMetadata';
import { getComponentStatsWidgetMetadata } from '@/components/stats-builder/metadata';
import StatsWidgetTitle from '@/components/stats/StatsWidgetTitle.vue';

export default defineComponent({
  name: 'StatsWidgetTitleRender',
  components: {
    StatsWidgetTitle,
  },

  props: {
    widgetData: {
      type: Object as PropType<WidgetTitleData>,
      required: false,
      default() {
        return {};
      },
    },
  },

  setup(props: { widgetData: WidgetTitleData}) {
    const config = ref(props.widgetData);

    watch(() => props.widgetData, async (newValue, oldValue) => {
      // Ne pas déclencher si c'est le même objet (même référence)
      if (newValue === oldValue) {
        return;
      }
      
      // Vérifier si les propriétés importantes ont vraiment changé
      if (oldValue && newValue
        && newValue.widgetName === oldValue.widgetName) {
        return;
      }
      
      const meta = getComponentStatsWidgetMetadata('StatsWidgetTitle');
      if (!meta) {
        return;
      }
      let updateRender = false;
      if (meta.Validate) {
        const valid = await meta.Validate(props.widgetData);
        updateRender = valid.success;
      }

      if (updateRender) {
        /* Si les données sont valides, on met à jour la config */
        config.value = props.widgetData;
      }
    }, { flush: 'post' });

    return {
      config,
    };
  },
});
